<template>
  <div class="u-s-box">
    <el-card>
      <el-table :data="tableData" class="wid100" :row-class-name="tableRowClassName" @selection-change="handleSelectionChange" :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109">
        <el-table-column type="selection" width="55" v-if="this.postAuditListcheckbox"></el-table-column>
        <el-table-column
          type="index"
          :index="indexMethod" align="center"
          :label="$t('lang.lab_index')"
          width="100px"
        ></el-table-column>
        <el-table-column prop="contact" :label="$t('lang.lab_contact')" width="300px"></el-table-column>
        <el-table-column prop="content" :label="$t('lang.lab_useContent')">
          <template slot-scope="scope">
            <el-tooltip
              placement="top"
              effect="light"
              v-if="scope.row.content&&scope.row.content.length> require('@/config/enum').tableDatamaxlength60"
              :disabled="false"
            >
              <div slot="content">
                <span >
                  {{ scope.row.content }}
                </span>
              </div>
              <div>
                {{ scope.row.content.substring(0, require('@/config/enum').tableDatamaxlength60) | valueIsNull }}
                <span
                  v-if="scope.row.content.length>require('@/config/enum').tableDatamaxlength60"
                >...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.content | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.lab_operation')" fixed="right" :width="require('@/config/enum').opr_width1">
          <template slot-scope="scope">
            <el-button class="orange" @click="deleteList(scope.row.id)">{{deletename}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="sizes, prev, pager, next, jumper"
          :page-count="pageCount"
          />
    </el-card>
  </div>
</template>

<script>
/**
 *@ClassName:useSensationList
 *@Description:用后感
 *@author:刘彦辰
 *@Copyright:格众科技
 *@date:2020-03-12
 */
export default {
  data() {
    return {
      pageCount: 0,
      pageNum: 1,
      pageSize: 10,
      tableData: [],
      multipleSelection: [], // 多选框
      postAuditListcheckbox: require('@/config/enum').postAuditListcheckbox, // 是否隐藏复选框
      deletename: require('@/config/enum').deletename
    }
  },
  created() {
    this.list()
  },
  methods: {
     // ID序号功能
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 列表隔行变色
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 用后感列表
    list() {
      let loading = this.$loading()
      this.$get(
        `/feedbacks?pageSize=${this.pageSize}&pageNo=${this.pageNum}`
      ).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 点击换页
    handleCurrentChange(val) {
      this.pageNum = val
      this.list()
    },
    // 点击更改每页容量
    handleSizeChange(val) {
      this.pageNum = 1
      this.pageSize = val
      this.list()
    },
    commit() {
      this.pageNum = 1
      this.list()
    },
    deleteList(id) {
      let loading = this.$loading()
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
          this.$delete(`/feedbacks/` + id).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                })
                this.commit()
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        })
        .catch(() => {
          loading.close()
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    }
  }
}
</script>

<style lang="scss">
  .el-tooltip__popper.is-light {
    max-width: 900px;
  }
</style>